import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import Spinner from '../Spinner'
import Input from '../Input'
import { getEndOfTheYearDate, getNewYearsEveDate } from '../../utils/functions'

const SupplierReceipt = (props) => {

    const { isOpen, closeModal, onClick, onClickDetailed, pendingApiCall } = props

    const [firstDate, setFirstDate] = useState(getNewYearsEveDate())
    const [lastDate, setLastDate] = useState(getEndOfTheYearDate())

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 mb-3"
                                >
                                    Ekstre
                                </Dialog.Title>
                                <div>
                                    <Input
                                        label='İlk Gün'
                                        value={firstDate}
                                        type='date'
                                        onChange={e => setFirstDate(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <Input
                                        label='Son Gün'
                                        value={lastDate}
                                        type='date'
                                        onChange={e => setLastDate(e.target.value)}
                                    />
                                </div>

                                <div className="mt-4 flex justify-between">
                                    <button
                                        type="button"
                                        className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200"
                                        onClick={() => onClick(firstDate, lastDate)}
                                        disabled={pendingApiCall}
                                    >
                                        Detaysız
                                        {pendingApiCall && <Spinner />}
                                    </button>
                                    <button
                                        type="button"
                                        className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200"
                                        onClick={() => onClickDetailed(firstDate, lastDate)}
                                        disabled={pendingApiCall}
                                    >
                                        Detaylı
                                        {pendingApiCall && <Spinner />}
                                    </button>
                                    <button
                                        type="button"
                                        className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                        onClick={closeModal}
                                    >
                                        İptal
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default SupplierReceipt